export const DIVIDER_WIDTH = 2
export const EMPTY_STRING = ''
export const ERROR_MESSAGE =
  'Oops, there was a problem. An unexpected error has occurred.  \nPlease try refreshing your page.'
export const FULL_HEIGHT = '100%'
export const FULL_WIDTH = '100%'
export const HALF_WIDTH = '50%'
export const HALF_OF_DIVIDER_WIDTH = DIVIDER_WIDTH / 2
